import React from 'react';
import '../css/ImageToggle.css';
import home from '../img/home.png';
import ductless from './../img/ductless.png';
import ducted from '../img/ducted.png';
import furnace from '../img/ducted-furnace.png';

const ImageToggle = (props) => {
	let src = home;
	let alt = props.content.home;

	switch(props.type) {
		case 'ducted':
			src=ducted;
			alt=props.content.ducted;
			break;
		case 'ducted-new':
			src=ducted;
			alt=props.content.ducted;
			break;
		case 'ducted-rep':
			alt=props.content.ducted;
			src=ducted;
			break;
		case 'ductless':
			src=ductless;
			alt=props.content.ductless;
			break;
		case 'furnace':
			src=furnace;
			alt=props.content.furnace;
			break;
		default:
			src=home;
			alt=props.content.home;
			break;
	}

	return (
		<div className="app__banner">
			<img src={src} alt={alt} />
		</div>
	);
}

export default ImageToggle;


// WEBPACK FOOTER //
// ./src/components/ImageToggle.js